//Global CSS
import '@/assets/css/reset.css'
import '@/assets/css/variables.css'
import '@/assets/css/themes.css'
import '@/assets/css/elements.css'
import '@/assets/css/utility.css'
import '@/assets/css/primevue.css'

//Vue
import {createApp} from 'vue'
import {createPinia} from 'pinia'

//PrimeVue
import PrimeVue from 'primevue/config'

//Services
import {router} from '@/routing/router.js'
import {initSentry} from '@/services/sentry.js'
import {primeVueConfig} from '@/services/primevue.js'
import {useErrorHandling} from '@/composables/use-error-handling.js'
import {useEnv} from '@/composables/use-env.js'

//Components
import App from './App.vue'
import Debug from '@/components/shared/dev/Debug.vue'

//Helper to set up mock service worker in local environment
//Test environment uses it's own Node implementation of MSW
const setupMockWorker = async () => {
  const {isLocal, useMocks} = useEnv()
  if (!isLocal.value || !useMocks.value) {
    return
  }
  try {
    const {worker} = await import('@/mock/worker.js')
    const {handlers} = await import('@/mock/handlers.js')
    console.log(`Setting up mock service worker API handlers:`)
    handlers.forEach(handler => {
      const {method, path} = handler.info
      if (path === '*') {
        console.log(` - Passthrough ${path}`)
      }
      else {
        console.log(` - ${method} ${path}`)
      }
    })
    worker.use(...handlers)
    await worker.start({
      onUnhandledRequest: 'warn',
      quiet: false,
    })
  }
  catch (error) {
    console.error('Failed to setup mock service worker', error)
  }
}

//Setup mock service worker
await setupMockWorker()

//Create app
const app = createApp(App)
const pinia = createPinia()

//Register plugins and services
app
  .use(pinia)
  .use(router)
  .use(PrimeVue, primeVueConfig)

//Register global components
app
  .component('Debug', Debug)

//Initialize Sentry
initSentry(app, router)

//Attach to Vue error handler
const {processError} = useErrorHandling()
app.config.errorHandler = processError

//Mount app
app
  .mount('#app')
